import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import HelpPopover from "./HelpPopover";
import NewIndustryPopover from "./NewIndustry";
import { db } from "../../../lib/firebaseCompat";
import { useOrganization } from "../../../hooks/useOrganization";
import cavsLogo from "../../../images/cavs-logo.png";

const activeStyle = ({ isActive }) =>
  isActive ? { backgroundColor: "#e6e6e6" } : {};

const LegacyNavLink = ({ hasLegacyEstimates }) => {
  if (!hasLegacyEstimates) return null;

  return (
    <NavLink
      className="secondary-text-color"
      style={activeStyle}
      to="/v3"
    >
      V3 Estimates
    </NavLink>
  );
}

export default function Authenticated() {
  const [hasLegacyEstimates, setHasLegacyEstimates] = useState(false);

  const organization = useOrganization();
  const orgId = organization.current?.id;

  useEffect(() => {
    if (!orgId) return;

    db.doc(`legacyCavs/${orgId}`)
      .get().then(({ exists }) => setHasLegacyEstimates(exists));
  }, [db, orgId]);

  return (
    <div className="navbar-fixed">
      <nav className="white app-bar fixed" role="navigation">
        <div className="nav-wrapper">
          <Link to="/" className="brand-logo">
            <img src={`../${cavsLogo}`} alt="CAVS logo" className="nav-logo" />
            <span className="right secondary-text-color site-title">
              Cost Analysis Valuation System
            </span>
          </Link>
          <ul className="right hide-on-med-and-down navlinks">
            <li>
              <NavLink
                className="secondary-text-color"
                style={activeStyle}
                to="/new"
              >
                <b>New Estimate</b>
              </NavLink>
            </li>
            <li>
              <NavLink
                className="secondary-text-color"
                style={activeStyle}
                to="/my"
              >
                My Estimates
              </NavLink>
            </li>
            <li>
              <NavLink
                className="secondary-text-color"
                style={activeStyle}
                to="/shared"
              >
                Shared Estimates
              </NavLink>
            </li>
            <li>
              <NavLink
                className="secondary-text-color"
                style={activeStyle}
                to="/archived"
              >
                Archived Estimates
              </NavLink>
            </li>
            <li>
              <LegacyNavLink hasLegacyEstimates={hasLegacyEstimates}/>
            </li>
            <li>
              <HelpPopover />
            </li>
            <li>
              <NewIndustryPopover />
            </li>
            <li>
              <div>
                <NavLink
                  className="secondary-text-color"
                  style={activeStyle}
                  to="/account"
                >
                  <i className="material-icons md-24">person_outline</i>
                </NavLink>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}
